import { MdAdd } from 'react-icons/md';
import styled from 'styled-components';

const Div = styled.div``;

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
`;

const Span = styled.span``;

const SelectHeader = styled.div`
  color: ${({ theme }) => theme.COLOR_GREY_TEXT};
  font-size: ${(props) => props.fontSize || '12px'};
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.4px;
`;

const Container = styled.div`
  margin: ${(props) => (props.margin ? props.margin : '0')};
  width: 100%;
`;

const Validation = styled.div`
  width: 100%;
  color: grey;
  font-size: 12px;
  line-height: auto;
  margin: 0;
  padding-left: 5px;
  margin-bottom: 1%;
  overflow: visible;
  white-space: wrap;
`;

const GroupContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 2px;
`;

const AddIcon = styled(MdAdd)`
  margin-right: 15px;
`;

const styledSelect = {
  Div,
  Span,
  SelectHeader,
  Container,
  Validation,
  GroupContainer,
  StyledDiv,
  AddIcon,
};

export default styledSelect;
